class ConfirmCloseModalController {
  constructor() {
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  confirm() {
    this.hideModal();
    if (this.onConfirm) this.onConfirm();
  }

  hideModal() {
    $('.modal').modal('hide');
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.YES'
      }, {
        literal: 'GLOBALS.BUTTON_ACTION.NO'
      }
    ];
  }
}

export default ConfirmCloseModalController;



// WEBPACK FOOTER //
// ./client/app/components/confirmCloseModal/confirmCloseModal.controller.js